import script from "./SalesSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./SalesSidebar.vue?vue&type=script&setup=true&lang=js"

import "./SalesSidebar.vue?vue&type=style&index=0&id=777b2c4c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-777b2c4c"]])

export default __exports__